import React, {useEffect, useState} from 'react';
import {Box, Card, Typography, useMediaQuery} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const AppBanner = () => {
    const [showBanner, setShowBanner] = useState(false);
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const tabletPhone = useMediaQuery('(max-width:768px)');

    const bannerShowHandler = () => {
        setShowBanner(false);
    };

    const handleInstallClick = () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then(() => {
                setDeferredPrompt(null);
                setShowBanner(false);
            });
        }
    };

    const handleBeforeInstallPrompt = (e) => {
        e.preventDefault();
        setDeferredPrompt(e);
    };

    useEffect(() => {
        // Check if the app is already installed
        const isInstalled =
            window.matchMedia('(display-mode: standalone)').matches ||
            window.navigator.standalone === true;

        if (isInstalled) {
            // App is installed, so do not show the banner.
            setShowBanner(false);
            return;
        }

        // App is not installed, so show banner after a delay.
        const timeoutId = setTimeout(() => {
            setShowBanner(true);
        }, 5000);

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        return () => {
            clearTimeout(timeoutId);
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    return (
        <Card
            sx={{
                position: 'fixed',
                top: showBanner ? "10px" : '-100%',
                right: "50%",
                transform: "translate(50%, 0)",
                width: '90%',
                zIndex: 'tooltip',
                height: '70px',
                display: tabletPhone ? 'flex' : 'none',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '10px 20px',
                transition: 'top 1s ease',
                boxShadow: 2,
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: "10px",
                }}
            >
                <button
                    style={{width: "fit-content"}}
                    className="btn btn-blue"
                    onClick={handleInstallClick}
                >
                    دانلود
                </button>
                <Typography sx={{fontSize: "16px", fontWeight: "bold",}}>
                    وب اپلیکیشن پُرتفویار
                </Typography>
            </Box>
            <CloseIcon onClick={bannerShowHandler} fontSize="medium" sx={{color: "#000"}}/>
        </Card>
    );
};

export default AppBanner;
